module.exports = __webpack_public_path__ + "img/vivo_06.a81d1a4e.jpg";